export default "__VITE_ASSET__x9lzpKtL__"